
<template>
    <div>
        <q-card class="text-caption">
            <q-card-section>
                <div>ADDRESS INFORMATION</div>
            </q-card-section>
            <q-separator/>
            <q-card-section>
                <div class="q-pb-md">
                    PERMANENT ADDRESS
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Address 1
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.PermanentAddress.Address1}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Address 2
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.PermanentAddress.Address2}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Address 3
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.PermanentAddress.Address3}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Postcode
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.PermanentAddress.Postcode}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        City
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.PermanentAddress.City}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        State
                    </div>
                    <div class="col" v-if="StoreStateAOD.AddressInformation.PermanentAddress.Country==='MALAYSIA'">
                        : {{StoreStateAOD.AddressInformation.PermanentAddress.State}}
                    </div>
                    <div class="col" v-if="StoreStateAOD.AddressInformation.PermanentAddress.Country!=='MALAYSIA'">
                        : {{StoreStateAOD.AddressInformation.PermanentAddress.StateForeign}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        Country
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.PermanentAddress.Country}}
                    </div>
                </div>
                <div class="q-py-md">
                    CORRESPONDENCE ADDRESS
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Address 1
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Address1}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Address 2
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Address2}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Address 3
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Address3}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Postcode
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Postcode}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        City
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.CorrespondenceAddress.City}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        State
                    </div>
                    <div class="col" v-if="StoreStateAOD.AddressInformation.CorrespondenceAddress.Country==='MALAYSIA'">
                        : {{StoreStateAOD.AddressInformation.CorrespondenceAddress.State}}
                    </div>
                    <div class="col" v-if="StoreStateAOD.AddressInformation.CorrespondenceAddress.Country!=='MALAYSIA'">
                        : {{StoreStateAOD.AddressInformation.CorrespondenceAddress.StateForeign}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Country
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Country}}
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryAddressInformation',
    data() {
        return {
            StoreStateAOD : store.state.AOD
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>